import { Menu } from "./Menu";
import { Root } from "./Root";

export * from "./TopNavLink";
export * from "./TopNavWrapper";

export const TopNav = Object.assign(Root, {
  Menu,
});
